import { createReducer } from '@reduxjs/toolkit';
import { clearState } from '../Actions/index';
import {
  fetchFileTypes,
  fetchIndustries,
  fetchPageTypes,
  fetchStates,
  fetchUserLevels,
  fetchSubscriptions,
  fetchCustomOptions,
  fetchExistingEmails,
  fetchEquipmentSearchData,
  fetchCategories,
  fetchSubCategories,
  fetchClients,
  fetchEquipmentListCustom,
  fetchTerritoryList,
} from '../Actions/CommonFields';
import { CommonFieldsReference } from '../Models/CommonFieldsReference';

const initialState: CommonFieldsReference = {
  states: [],
  userLevels: [],
  industries: [],
  fileTypes: [],
  pageTypes: [],
  subscriptions: [],
  customOptions: [],
  existingEmails: [],
  manufacturers: [],
  categories: [],
  subCategories: [],
  equipmentSearchData: null,
  clients: [],
  equipmentListCustom: [],
  territories: [],
};

const CommonFieldsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchStates.fulfilled, (state, action) => {
      return { ...state, states: action.payload };
    })
    .addCase(fetchUserLevels.fulfilled, (state, action) => {
      return { ...state, userLevels: action.payload };
    })
    .addCase(fetchPageTypes.fulfilled, (state, action) => {
      return { ...state, pageTypes: action.payload };
    })
    .addCase(fetchIndustries.fulfilled, (state, action) => {
      return { ...state, industries: action.payload };
    })
    .addCase(fetchFileTypes.fulfilled, (state, action) => {
      return { ...state, fileTypes: action.payload };
    })
    .addCase(fetchSubscriptions.fulfilled, (state, action) => {
      return { ...state, subscriptions: action.payload };
    })
    .addCase(fetchCustomOptions.fulfilled, (state, action) => {
      return { ...state, customOptions: action.payload };
    })
    .addCase(fetchExistingEmails.fulfilled, (state, action) => {
      return { ...state, existingEmails: action.payload };
    })
    .addCase(fetchCategories.fulfilled, (state, action) => {
      return { ...state, categories: action.payload };
    })
    .addCase(fetchSubCategories.fulfilled, (state, action) => {
      return { ...state, subCategories: action.payload };
    })
    .addCase(fetchEquipmentSearchData.fulfilled, (state, action) => {
      return { ...state, equipmentSearchData: action.payload };
    })
    .addCase(fetchClients.fulfilled, (state, action) => {
      return { ...state, clients: action.payload };
    })
    .addCase(fetchEquipmentListCustom.fulfilled, (state, action) => {
      return { ...state, equipmentListCustom: action.payload };
    })
    .addCase(fetchTerritoryList.fulfilled, (state, action) => {
      return { ...state, territories: action.payload };
    })
    .addCase(clearState, (state, action) => {
      return initialState;
    });
});

export default CommonFieldsReducer;
